module.exports = __webpack_public_path__ + "media/img/help_center/Student_Message_01-5096a000b506e1372e3671e9dd32bd76.jpg";